import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import './css/common.css'
import 'mint-ui/lib/style.css'
import vant from 'vant';
import { Col, Row } from 'vant'
import 'vant/lib/index.css';
import './js/common/derective';
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { VueAxios } from './utils/request'
import { Notify } from 'vant';
import { Toast } from 'vant';
import {Modal} from "ant-design-vue";
Vue.use(Modal)
import common from "src/utils/src.js"; // global js
Vue.prototype.$common = common;
// mount axios to `Vue.$http` and `this.$http`
Vue.use(VueAxios)
Vue.use(vant);
Vue.prototype.$toast = Toast
Vue.use(Notify);
Vue.use(Col);
Vue.use(Row);
Vue.config.productionTip = false
// import Vconsole from 'vconsole';
// new Vconsole();
// const router = routerConfig();
// router.afterEach((to, from, next) => {
//     window.scrollTo(0, 0)
// })
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
new Vue({
    router: router(),
    store,
    render: h => h(App),
}).$mount('#app')
